





































































import { Component, Vue, Prop } from "vue-property-decorator";
import { getBiduiWenli } from "@/request/idr";
@Component({})
export default class IdrBiduiWenli extends Vue {
  @Prop()
  private tongues: any;
  private loaded: boolean = false;
  private filters: any = {
    类别: "苔质",
    特征: "灰度共生特征"
  };
  private message: any = {};
  private tubiao: any = {
    title: {
      textStyle: {
        color: "#333333",
        fontSize: 14,
        fontWeight: "normal"
      }
    },
    legend: {
      orient: "vertical",
      left: "0%",
      top: "10%",
      itemGap: 20
    },
    grid: {},
    tooltip: {},
    radar: {
      center: ["60%", "50%"],
      indicator: [],
      radius: "60%",
      nameGap: 30
    },
    series: [
      {
        type: "radar"
      }
    ]
  };
  private th: any[] = [];
  private tr: any[] = [];
  /**
   * @description 获得纹理特征
   */
  private fetchWenli() {
    const ids: any[] = [];
    this.tongues.map((item: any) => {
      ids.push(item.tongue_id);
    });
    const params: any = {
      tongue_ids: ids,
      类别: this.filters["类别"],
      特征: this.filters["特征"]
    };
    getBiduiWenli(this, params).then((data: any) => {
      this.message = data;
      this.createTubiao();
      this.th = this.message["详细参数列表"].splice(0, 1)[0];
      this.th.splice(0, 1);
      this.tr = this.message["详细参数列表"];
    });
  }
  /**
   * @description 改变类别
   */
  private changeLeilie(leibie) {
    this.filters["类别"] = leibie;
    this.loaded = false;
    this.fetchWenli();
  }
  /**
   * @description 改变特征
   */
  private changeTezheng(tezheng) {
    this.filters["特征"] = tezheng;
    this.loaded = false;
    this.fetchWenli();
  }
  /**
   * @description 创建图表
   */
  private createTubiao() {
    this.tubiao.title.text = this.message["雷达图名称"];
    const nameIndicator: any[] = [];
    this.message["雷达图"]["name"].forEach((item: any) => {
      nameIndicator.push({
        name: item
      });
    });
    this.tubiao.radar.indicator = nameIndicator;
    this.tubiao.series[0].data = this.message["雷达图"]["data"];
    this.loaded = true;
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchWenli();
  }
}
